module.exports = __webpack_public_path__ + "11450dcaaa9ae97093fb45a1b0d0bf2a.png";